import React from 'react'
import { IconChoices } from '../Icon'
import { BreadcrumbItem } from './BreadcrumbItem'

export interface BreadcrumbItemData {
  _id: string
  title: string
  url: string
  dropParentId?: string | null
}

interface BreadcrumbProps {
  items: BreadcrumbItemData[]
  rootIcon: IconChoices
  rootIconSize?: number
  rootLabel?: string
  droppableType?: 'document' | 'binder'
  dropEnabled?: boolean
  dropStartIndex?: number
  disableDropOnLastItem?: boolean
}

export const Breadcrumb = ({
  items,
  rootIcon,
  rootIconSize = 24,
  rootLabel,
  droppableType = 'document',
  dropEnabled = true,
  dropStartIndex = 0,
  disableDropOnLastItem = false,
}: BreadcrumbProps): JSX.Element => {
  return (
    <div className="flex flex-wrap gap-2">
      {items.map((item, index) => {
        return (
          <div className="flex space-x-2" key={item._id}>
            <BreadcrumbItem
              index={index}
              item={item}
              totalItems={items.length - 1}
              rootIcon={rootIcon}
              rootIconSize={rootIconSize}
              rootLabel={rootLabel}
              droppableType={droppableType}
              dropEnabled={dropEnabled && index >= dropStartIndex}
              disableDropOnLastItem={disableDropOnLastItem}
            />
          </div>
        )
      })}
    </div>
  )
}
